import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`To set up PagerDuty alerts, you must:`}</p>
    <ol>
      <li parentName="ol">{`Create a PagerDuty integration key.`}</li>
      <li parentName="ol">{`Provide that integration key to GraphOS Studio.`}</li>
    </ol>
    <h4 {...{
      "id": "1-create-a-pagerduty-integration-key"
    }}><a parentName="h4" {...{
        "href": "#1-create-a-pagerduty-integration-key"
      }}>{`1. Create a PagerDuty integration key`}</a></h4>
    <p>{`Generate an `}<a parentName="p" {...{
        "href": "https://support.pagerduty.com/docs/generating-api-keys#events-api-keys"
      }}>{`integration key`}</a>{` for the service that should receive alerts in PagerDuty.
You can select an `}<a parentName="p" {...{
        "href": "#existing-services"
      }}>{`existing service`}</a>{` that corresponds to your GraphQL API or `}<a parentName="p" {...{
        "href": "#adding-a-service"
      }}><strong parentName="a">{`Add New Service`}</strong></a>{`.`}</p>
    <h5 {...{
      "id": "existing-services"
    }}><a parentName="h5" {...{
        "href": "#existing-services"
      }}>{`Existing services`}</a></h5>
    <ol>
      <li parentName="ol">{`In PagerDuty, go to your existing service's `}<strong parentName="li">{`Integrations`}</strong>{` tab and click `}<strong parentName="li">{`new integration`}</strong>{`.`}</li>
      <li parentName="ol">{`Enter an `}<strong parentName="li">{`Integration Name`}</strong>{`, for example, `}<inlineCode parentName="li">{`GraphOS Alerts`}</inlineCode>{`.`}</li>
      <li parentName="ol">{`Under `}<strong parentName="li">{`Integration type`}</strong>{`, choose `}<strong parentName="li">{`Use our API directly`}</strong>{` and `}<strong parentName="li">{`Events API v2`}</strong>{`.`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Add Integration`}</strong>{`.`}</li>
      <li parentName="ol">{`From the Integrations tab, copy the generated integration key from the table for use in the `}<a parentName="li" {...{
          "href": "#2-provide-the-integration-key-to-studio"
        }}>{`next step`}</a>{`.`}</li>
    </ol>
    <h5 {...{
      "id": "adding-a-service"
    }}><a parentName="h5" {...{
        "href": "#adding-a-service"
      }}>{`Adding a service`}</a></h5>
    <ol>
      <li parentName="ol">{`In PagerDuty, under `}<strong parentName="li">{`Integration Settings`}</strong>{`, choose `}<strong parentName="li">{`Use our API directly`}</strong>{` and use `}<strong parentName="li">{`Events API v2`}</strong>{`.`}</li>
      <li parentName="ol">{`Enter an `}<strong parentName="li">{`Integration Name`}</strong>{`, for example, `}<inlineCode parentName="li">{`GraphOS Alerts`}</inlineCode>{`, and complete the add service flow.`}</li>
      <li parentName="ol">{`From the `}<strong parentName="li">{`Integrations`}</strong>{` tab, copy the generated integration key from the table for use in the `}<a parentName="li" {...{
          "href": "#2-provide-the-integration-key-to-studio"
        }}>{`next step`}</a>{`.`}</li>
    </ol>
    <h4 {...{
      "id": "2-provide-the-integration-key-to-studio"
    }}><a parentName="h4" {...{
        "href": "#2-provide-the-integration-key-to-studio"
      }}>{`2. Provide the integration key to Studio`}</a></h4>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`In `}<a parentName="p" {...{
            "href": "https://studio.apollographql.com/?referrer=docs-content"
          }}>{`GraphOS Studio`}</a>{`, specify a name for this notification channel in the `}<strong parentName="p">{`Channel Name`}</strong>{` field.`}</p>
        <ul parentName="li">
          <li parentName="ul">{`This name must be unique among your graph's notification channels.`}</li>
          <li parentName="ul">{`This name does not have to match the name of the PagerDuty service, but it's recommended for simplicity.`}</li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the `}<strong parentName="p">{`PagerDuty Integration Key`}</strong>{` field, paste the integration key you obtained in `}<a parentName="p" {...{
            "href": "#1-create-a-pagerduty-integration-key"
          }}>{`Create a PagerDuty integration key`}</a>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`Done`}</strong>{`.`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      